import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import naive from 'naive-ui'
import axios from 'axios'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import ElementPlus from 'element-plus'

let refresh = {func:null}
let reloadTimeCount = 0;
const app = createApp(App);
// 全局注册el-icon
for (const [name, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(name, component);
}
app.provide('reload', () => {
    refresh.func();
    setTimeout(()=>{
        refresh.func();
    },100);
    if(reloadTimeCount == 0){
        setTimeout(()=>{
            refresh.func();
        },500);
        reloadTimeCount ++;
    }
})
app.provide('$axios',axios);
app.use(naive).use(router).use(ElementPlus).mount('#app')
